<template>
  <div>
    <form
      :action="url"
      ref="form"
      method="post"
      novalidate="novalidate"
      :target="isIframe ? '_blank' : '_self'"
      class="height-0"
    >
      <div class="username-container ">
        <input
          data-val="true"
          data-val-required="The Username field is required."
          id="Username"
          name="Username"
          type="text"
          :value="account.username"
        />
      </div>
      <div class="password-container">
        <input
          data-val="true"
          data-val-required="The Password field is required."
          id="Password"
          name="Password"
          type="password"
          :value="account.password"
        />
      </div>
    </form>
    <button class="button full-100 is-primary" @click="handlePlayOnWeb()">
      {{ $t('playGameBtn') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'LoginSlotXO',
  props: {
    account: {
      type: Object
    },
    trigger: {
      type: Number
    }
  },
  watch: {
    trigger: {
      // immediate: true,
      async handler() {
        this.handlePlayOnWeb()
      }
    }
  },
  data() {
    return {
      url: 'https://www.slotxo.com/SignIn',
      isIframe: process.env.VUE_APP_IFRAME === 'true'
    }
  },
  methods: {
    handlePlayOnWeb() {
      this.$refs.form.submit()
    }
  }
}
</script>

<style scoped lang="scss">
.height-0 {
  height: 0px !important;
  visibility: hidden;
}
</style>
